import api from "./base";

export interface Holiday {
  id: string;
  name: string;
  name_fr?: string;
  name_ar: string;
  name_en: string;
  description: string;
  date: string; // YYYY-MM-DD
  type: string;
  country: string;
  country_code: string;
}

export interface HolidaysResponse {
  year: number;
  country: string;
  country_code: string;
  language: string;
  holidays: Holiday[];
}

export const holidayService = {
  getHolidays: async (): Promise<HolidaysResponse> => {
    const response = await api.get<HolidaysResponse>(`api/v1/holidays/`);
    return response.data;
  },
};